__turbopack_context__.v({
  "base": "Divider-module__OFY-ha__base",
  "color-accent": "Divider-module__OFY-ha__color-accent",
  "color-error": "Divider-module__OFY-ha__color-error",
  "color-info": "Divider-module__OFY-ha__color-info",
  "color-jets-beige": "Divider-module__OFY-ha__color-jets-beige",
  "color-jets-black": "Divider-module__OFY-ha__color-jets-black",
  "color-jets-red": "Divider-module__OFY-ha__color-jets-red",
  "color-link": "Divider-module__OFY-ha__color-link",
  "color-neutral-100": "Divider-module__OFY-ha__color-neutral-100",
  "color-neutral-200": "Divider-module__OFY-ha__color-neutral-200",
  "color-neutral-300": "Divider-module__OFY-ha__color-neutral-300",
  "color-neutral-400": "Divider-module__OFY-ha__color-neutral-400",
  "color-neutral-500": "Divider-module__OFY-ha__color-neutral-500",
  "color-neutral-600": "Divider-module__OFY-ha__color-neutral-600",
  "color-neutral-700": "Divider-module__OFY-ha__color-neutral-700",
  "color-neutral-800": "Divider-module__OFY-ha__color-neutral-800",
  "color-neutral-900": "Divider-module__OFY-ha__color-neutral-900",
  "color-overImage": "Divider-module__OFY-ha__color-overImage",
  "color-overPrimary": "Divider-module__OFY-ha__color-overPrimary",
  "color-primary": "Divider-module__OFY-ha__color-primary",
  "color-success": "Divider-module__OFY-ha__color-success",
  "color-warning": "Divider-module__OFY-ha__color-warning",
});
